module.exports = __webpack_public_path__ + "img/5-1.8175dbd3.svg";